module.exports = __webpack_public_path__ + "img/monitor-tree.3fcdabe6.png";